var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_30",
    transform: "translate(0.0238095) scale(0.010582 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_30",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACnklEQVR4nO2cPU9UQRSGHz+yS0NCjcZKC+y04SeojbbaWVlpKG3tWH6ClQnID9DKX6DSiBUNlSbLlprFEBMNUOzeiJdc7+zO3DMfvk/yNsCEc55MbuZk7i4IIYQQQoi/WQA2gANgBAymPxMBWQY+Aie1fAKuRayrKG4BXzgvucoQWI1WXSE8BI5ollzlJ/A4Uo1Zc4nJM7hNcD0vgcsR6s2SReANs0uu8g5YMq86M64De8wvuco+sGJcezbcAb7hL7nKGLhv2kEGPAF+EU5yld/Ac8M+kmUB2CS84Ho2aR9uevwZiOrHx8H091myDOzQveQqO9P/2UTbKWcQomlr2oaQrnJA83BT38n1jMK0bscj3IaQrtI03LiszYJ5h5CuUh9uihC9CLwlvtx6zg432Yu+QZghpKtUw03Wou8B34kvsy2ug1KSrDEZGGJLDJmk6AOviC+laNFNNyGlJAluA1+JL6No0bGHkOJFpzaEFCl6icmBP3bzljG/uUl9COkq+8DNAP6cuEvYm5DcMgYeeFtsocQhZJ4cAy+AC346z9MDXifQYGrZIvDNy3oCTaWadReBrlt/yL+vgf5nRji4uWhQSOkcu/yRq+gtj0JKJ6ibHpMJcEj8Z2Iqmek1BN/jyYnn+tyY25ee0UZItBESbYREGyHRRpT8MYRZTwidnqC0o42QaCMk2giJNkKijZBoIyTaCIk2QqKNkGgjJNoIiTZCoo2QaCMk2giJNkKijZBoIyTaCIk2QqKNkGgjJNqIkt/rSOpNV+1oIyTaCF/RP4JUkQdjn8W+ovc81+eEV6++orc91+dE1F77wGfif3Cn6+ySwHeTXqVs2bvAlWC2POkDz4APwCHx5fjmEHgPPCWBnSyEEEIIIYQQQgiRGqfVVpDD1gzQ4wAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.335c761f4f59ef5625a7fa450e743b28.svg";
export { ForwardRef as ReactComponent };